import { render, staticRenderFns } from "./ProfileInfoConfig.vue?vue&type=template&id=5d422c62&scoped=true"
import script from "./ProfileInfoConfig.vue?vue&type=script&lang=ts"
export * from "./ProfileInfoConfig.vue?vue&type=script&lang=ts"
import style0 from "./ProfileInfoConfig.vue?vue&type=style&index=0&id=5d422c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d422c62",
  null
  
)

export default component.exports